export default "__VITE_ASSET__CdZzUGqN__"